import React, { useEffect, useState, useRef } from "react";
import HeaderV2 from '../../components/headerV2';
import * as S from './styles'

import FilterCompendio from "../../components/compendio/filter-compendio";
import CompendioList from "../../components/compendio/compendio-list";
import CardsInformation from "../../components/compendio/cards-information";
import InputV3 from "../../components/input/novo/input_v3";
import Select from "../../components/select/select_v2"
import api from "../../services/api";
import Paginator from "../../components/paginator";
import Modal from "../../components/modal/modalGenericV2";
import PaginatorV2 from "../../components/paginator/indexV2";
import PragaDossieDrawer from "../../components/praga-dossie-drawer";
import { openCulturaUrl } from "../../utils/culturasPdf";

const USER = JSON.parse(localStorage.getItem("@userinfo"));

const Compendio = () => {
    const [limit, setLimit] = useState(15);
    const [offset, setOffset] = useState(0);
    const [total, setTotal] = useState(0);

    const [cultura, setCultura] = useState("*");
    const [culturas, setCulturas] = useState([]);
    const [praga, setPraga] = useState("*")
    const [pragas, setPragas] = useState([]);
    const [uf, setUf] = useState("*");
    const [ufs, setUfs] = useState([]);
    const [produto, setProduto] = useState("*")
    const [produtos, setProdutos] = useState([]);

    const [filters, setFilters] = useState([]);

    const [orderBy, setOrderBy] = useState({ field: "data_revisao", order: "DESC" });
    const [isDispensed, setIsDispensed] = useState(false);
    const [activeIngredients, setActiveIngredients] = useState([]);
    const [manufacturers, setManufacturers] = useState([]);
    const [productClasses, setProductClasses] = useState([]);
    const [toxicologicalClasses, setToxicologicalClasses] = useState([]);
    const [exceptions, setExceptions] = useState([]);
    const [aplicationModes, setAplicationModes] = useState([]);
    const [dose, setDose] = useState(0);
    const [numeroAplicacoes, setNumeroAplicacoes] = useState(0)

    const [responseProducts, setResponseProducts] = useState([])
    const [dossieOpen, setDossieOpen] = useState(false);
    const [dossie, setDossie] = useState({ id: null, name: "" });

    const [loadCompendio, setLoadCompendio] = useState(false)


    const removeDuplicados = (lista = []) => {
        const seen = new Set();
        return (lista || []).filter((item) => {
            const val = typeof item === 'string' ? item : item?.value ?? item?.label ?? '';
            if (seen.has(val)) return false;
            seen.add(val);
            return true;
        });
    };

    const ordenarLista = (lista = []) =>
        [...(lista || [])].sort((a, b) => {
            const valA = (typeof a === 'string' ? a : a?.label ?? a?.value ?? '').toString();
            const valB = (typeof b === 'string' ? b : b?.label ?? b?.value ?? '').toString();
            return valA.localeCompare(valB, 'pt-BR', { sensitivity: 'base' });
        });

    // Permite buscar as UFs digitando tanto a sigla (ex: "SP") quanto o nome (ex: "São Paulo"),
    // seguindo o mesmo padrão usado em src/services/estados.js
    const comSearchTermsUf = (lista = []) =>
        (lista || []).map((item) =>
            typeof item === 'string'
                ? item
                : { ...item, searchTerms: [item.label, item.value, ...(item.searchTerms || [])] }
        );

    const getFilters = async () => {
        try {
            const response = await api.get('/compendio/filters');
            const filters = response.data;

            const culturasOrdenadas = ordenarLista(filters?.cultures ?? []);
            const ufsSemDuplicadosOrdenadas = comSearchTermsUf(ordenarLista(removeDuplicados(filters?.states ?? [])));

            setFilters(filters);
            setCulturas(culturasOrdenadas);
            setPragas((filters?.pests ?? []).map(p => ({ ...p, searchTerms: [p.label, ...(p.nomes_vulgares || [])] })));
            setUfs(ufsSemDuplicadosOrdenadas.map(uf => ({ ...uf, searchTerms: [uf.label, uf.value] })));
            setProdutos((filters?.products ?? []).map(p => ({ ...p, searchTerms: [p.label, ...(p.principios_ativos || [])] })));
        } catch (error) {
            console.error(error);
        }
    }

    const getCompendio = async () => {
        const isEmpty = (v) => v === undefined || v === null || v === "" || v === "*";
        if (isEmpty(cultura) && isEmpty(praga) && isEmpty(produto) && isEmpty(uf)) {
            setLoadCompendio(false);
            return;
        }

        try {
            const response = await api.post(
                `/compendio/v3/${cultura || '*'}/${praga || '*'}/${produto || '*'}/${uf || '*'}?limit=${limit}&offset=${offset}`,
                {
                    order_by: orderBy,
                    dispensed: isDispensed,
                    active_ingredients: activeIngredients,
                    manufacturer: manufacturers,
                    product_classes: productClasses,
                    toxicological_classes: toxicologicalClasses,
                    exceptions,
                    aplication_modes: aplicationModes,
                    dose,
                    numeroAplicacoes
                }
            );

            const filters = response.data.filters;
            const response_products = response.data.response.products;
            const total_products = response.data.response.total;

            const culturasOrdenadas = ordenarLista(filters?.cultures ?? []);
            const ufsSemDuplicadosOrdenadas = comSearchTermsUf(ordenarLista(removeDuplicados(filters?.states ?? [])));

            setTotal(total_products);
            setFilters(filters);
            setProdutos(filters?.products ?? []);
            setResponseProducts(response_products);

            setLoadCompendio(false);
        } catch (error) {
            console.error(error);
            setLoadCompendio(false);
        }
    };


    const updateFilter = (f) => {
        setOrderBy(f.order_by)
        setActiveIngredients(f.active_ingredients)
        setManufacturers(f.manufacturer)
        setProductClasses(f.product_classes)
        setToxicologicalClasses(f.toxicological_classes)
        setExceptions(f.exceptions)
        setAplicationModes(f.aplication_modes)
        setDose(f.dose)
        setNumeroAplicacoes(f.numero_aplicacoes)

        setTimeout(() => {
            setLoadCompendio(true)
        }, 500);
    }

    const changeCulture = (v) => {
        setCultura(v.value)
    }
    const changePest = (v) => {
        setPraga(v.value)
    }
    const changeUf = (v) => {
        setUf(v.value)
    }
    const changeProduct = (v) => {
        setProduto(v.value)
    }

    const updateLimitOffset = (l, o) => {
        if (l !== limit || o !== offset) {
            setLimit(l)
            setOffset(o)

            setLoadCompendio(true)
        }
    }


    useEffect(() => {
        if (cultura !== "*" || praga !== "*" || uf !== "*" || produto !== "*") {
            setLoadCompendio(true)
        }
    }, [cultura, praga, uf, produto])

    const isDispensedMounted = useRef(false);

    useEffect(() => {
        if (isDispensedMounted.current) {
            setLoadCompendio(true);
        } else {
            isDispensedMounted.current = true;
        }
    }, [isDispensed])

    useEffect(() => {
        if (loadCompendio) {
            getCompendio()
        }
    }, [loadCompendio])

    const [width, setWidth] = useState(window.innerWidth);
    const [showFilters, setShowFilters] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const receiveShowFilters = (isShowFilters) => {
        setShowFilters(isShowFilters);
    }

    useEffect(() => {
        getFilters();
    }, []);

    return (
        <S.Container>
            <HeaderV2 title="Compêndio Agrícola" />

            <S.Wrapper>
                <S.ContainerSearchs>
                    <S.Searchs>
                        <Select
                            id='cultura'
                            className="select"
                            label='Cultura'
                            options={culturas}
                            onChange={(e) => changeCulture(e)}
                            value={cultura}
                            searchPhoto
                            isClearable={true}
                            selectUniqueOption={false}
                            isCompact={true}
                            isSearch={true}
                            loading={loadCompendio}
                            disabled={loadCompendio}
                            marginBottom="0px"
                            height="48px"
                        />

                        <Select
                            id='praga'
                            className="select"
                            label='Praga ou Alvo'
                            options={pragas}
                            onChange={(e) => changePest(e)}
                            value={praga}
                            searchPhoto
                            highlightScientificName
                            isClearable={true}
                            selectUniqueOption={false}
                            isCompact={true}
                            isSearch={true}
                            loading={loadCompendio}
                            disabled={loadCompendio}
                            marginBottom="0px"
                            height="48px"
                        />

                        <Select
                            name="estado"
                            className="select"
                            label='UF de aplicação'
                            id='estado'
                            value={uf}
                            disabled={loadCompendio}
                            onChange={(e) => changeUf(e)}
                            options={ufs}
                            isCompact={true}
                            isSearch={true}
                            isClearable={true}
                            selectUniqueOption={false}
                            loading={loadCompendio}
                            marginBottom="0px"
                            height="48px"
                        />
                    </S.Searchs>
                </S.ContainerSearchs>

                <S.SearchBody>
                    {width > 768 && (
                        <FilterCompendio
                            isDispensed={isDispensed}
                            setIsDispensed={setIsDispensed}
                            filters={{ ...filters, order_by: orderBy }}
                            updateFilter={(f) => updateFilter(f)}
                            loading={loadCompendio}
                        />
                    )}

                    <CompendioList
                        isDispensed={isDispensed}
                        produtosOptions={produtos}
                        p={produto}
                        produtos={responseProducts}
                        selecionaProduto={(p) => changeProduct(p)}
                        loading={loadCompendio}
                        total={total}
                        showFilters={receiveShowFilters}
                        cultura={cultura}
                        praga={praga}
                        uf={uf}
                    />
                </S.SearchBody>

                <PaginatorV2
                    perPage={limit}
                    total={total}
                    onChange={(limit, offset) => updateLimitOffset(limit, offset)}
                    totalItens={responseProducts.length}
                />
            </S.Wrapper>

            <PragaDossieDrawer
                pestId={dossie.id}
                pestName={dossie.name}
                isOpen={dossieOpen}
                onClose={() => setDossieOpen(false)}
            />

            <Modal
                show={showFilters}
                size="sm"
                onHide={() => {
                    setShowFilters(false);
                }}
            >
                <FilterCompendio
                    isDispensed={isDispensed}
                    setIsDispensed={setIsDispensed}
                    filters={{ ...filters, order_by: orderBy }}
                    updateFilter={(f) => updateFilter(f)}
                    loading={loadCompendio}
                />
            </Modal>
        </S.Container>
    );
};

export default Compendio;